import UnavailableBannerContainer from './UnavailableBannerContainer';

export default UnavailableBannerContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/UnavailableBanner/index.js